import { render, staticRenderFns } from "./AppCanvas.vue?vue&type=template&id=dddc296e&"
import script from "./AppCanvas.vue?vue&type=script&lang=js&"
export * from "./AppCanvas.vue?vue&type=script&lang=js&"
import style0 from "./AppCanvas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports